export default __webpack_public_path__ + "static/media/icon-adderss.56630741.svg";